<template lang="pug">
.fpui-store-package-detail
  .return
    fpui-button(
      unbordered
      color="blue",
      icon="fpui fpui-chevron-left",
      left
      @click="$emit('close')"
    ) {{ "fpstore.return" | translate }}
  .logo(@click="openPreview(item.getImage())")
    img(:src='item.getImage()', :alt='`${item.name}-image`')
  .price-line
    .price {{ item.getPrice() }}
    .version-container
      fpui-input-select(
        :clearable='false'
        :options='versionsOptions',
        show-selected,
        v-model='version',
        @input='onVersionInput($event)'
      )
    .buttons-container
      .owned(v-if='item.owned')
        .installed(v-if="item.type == 'modules'")
          fpui-button(
            left='left',
            color='red',
            icon='fpui fpui-remove',
            @click='$emit("remove", item)',
            v-if='item.installed == true && !isSystem'
          ) {{ 'Remove' | translate }}
          fpui-button(
            left='left',
            color='blue',
            icon='fpui fpui-pencil',
            @click='$emit("edit", item)',
            v-if='showEdit'
          ) {{ 'Edit' | translate }}
          fpui-button(
            left='left',
            color='blue',
            icon='fpui fpui-plus',
            @click='$emit("install", item)',
            v-if='item.installed == false'
          ) {{ 'Install' | translate }}
        .owned-button(v-if="item.type != 'modules'")
          fpui-button(color='green', icon='fpui fpui-check', left='left')
            | {{ 'Owned' | translate }}
  .previews(v-if="item.preview")
    .line
      .preview(:key='index', v-for="preview, index in item.preview", @click="openPreview(preview, index)")
        img(:src='preview', :alt='`${item.name}-preview`')
  fpui-preview-lightbox(
    v-if='showPreviewLightbox',
    @close='closeLightbox',
    @open='activePreview = $event'
    :images='item.preview'
    :active='activePreview'
  )
  h2.name {{ item.getName() }}
    .author {{ item.getAuthor() }}

  .note
    fpui-stars(:value="item.getStar()")
    .value {{item.getStar()}}

  .long_description
    hr
    h3 {{ "fpstore.description" | translate }}
    p(v-html="item.getLongDescription()")


  .comments(v-if="item.comments")
    hr
    h3 {{ "fpstore.comments" | translate }}
    .comment(:key='index', v-for="comment, index in item.comments")
      .head
        .username {{comment.username}}
        .date {{comment.createdAt|date:'dd/MM/yyyy'}}
      .text {{comment.text}}
      .note-comment
        fpui-stars(:value="comment.note")

</template>

<script>
  import get from 'lodash/get'
  import FpuiStars from './FpuiStars.vue'
  import FpuiPreviewLightbox from './FpuiPreviewLightbox'
  export default {
    name: 'FpuiPackageDetail',
    components: { FpuiStars, FpuiPreviewLightbox },
    props: {
      item: Object
    },
    data () {
      return {
        unsusbscribe: null,
        activePreview: 0,
        showPreviewLightbox: false
      }
    },
    created () { this.initVersion() },
    computed: {
      versionsOptions () {
        let versions = this.item.getVersions()
        return versions.map(value => ({ label: value, value }))
      },
      version: {
        get () {
          return get(this.$store, `state.packages.installed.${this.item.id}.version`) || this.item.version
        },
        set (val) { this.item.update('version', val) }
      },
      showEdit () {
        if (this.item.consumer === 'app' || this.item.consumer === 'api') {
          return this.item.installed === true && this.item.source && this.item.source.moduleOptions && Object.keys(this.item.source.moduleOptions).length > 0
        }
        return false
      },
      isSystem () {
        const itemCategories = Array.isArray(this.item.category) ? this.item.category : [this.item.category]
        return itemCategories.includes('System')
      }
    },
    mounted () {
      this.unsusbscribe = this.$store.subscribe(({type}) => {
        if (type === 'PACKAGES_SET_INSTALLED') {
          let version = get(this.$store, `state.packages.installed.${this.item.id}.version`)
          if (version) this.item.update('version', version)
        }
      })
    },
    methods: {
      initVersion () {
        let version = get(this.$store, `state.packages.installed.${this.item.id}.version`)
        if (version) {
          if (version === 'latest') this.version = this.versionsOptions[0].value
          else this.version = version
        }
      },
      onVersionInput (value) {
        this.$emit('version', { item: this.item, version: value })
      },
      closeLightbox () {
        this.showPreviewLightbox = false
      },
      openPreview (image, index) {
        this.activePreview = index
        this.showPreviewLightbox = true
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";
.fpui-store-package-detail {
  .return {
    position: absolute;
    top:0;
    right:0;
  }
  .logo {
    height:200px;
    cursor: pointer;
    width:350px;
    position: absolute;
    left:10px;
    top:40px;
    img {
      max-width: 100%;
      padding:0;
      margin:0;
      position: absolute;
      left:50%;
      top:50%;
      transform:translate(-50%,-50%);
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
      max-height: 100%;
    }
  }
  .name {
    position: absolute;
    left: 10px;
    margin:0;
    top: 0px;
  }
  .author {
    font-size:16px;
    color:#888;
    display: inline;
    margin-left:10px;
    text-align:right;
    line-height: 25px;
  }
  .price-line {
    font-size:20px;
    position: absolute;
    top:250px;
    left:0px;
    width:70%;
    .price {
      display: inline-block;
      margin-right: 20px;
    }
    .buttons-container {
      display: inline-block;
      .fpui-button {
        margin-left: 10px;
      }
    }
    .version-container {
      display: inline-block;
      vertical-align: middle;
      width: 100px;
      height: 34px;
      font-size: 14px;
      .content {
        height: 34px;
        .activeLabel {
          height: 34px;
          .basic-label {
            line-height: 34px;
          }
        }
      }
    }
  }
  .previews {
    position:absolute;
    right:0;
    top:50px;
    height:170px;
    overflow: auto;
    left:450px;
    white-space: nowrap;
    .preview {
      height:150px;
      width:250px;
      display: inline-block;
      margin: 0px 5px;
      img {
        width: 100%;
        height: 150px;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
        object-fit: cover;
        cursor: pointer;
      }
    }
  }
  .note {
    position: absolute;
    top:240px;
    right:0;
    color:#888;
    .fpui-stars {
      display: inline-block;
    }
    .value {
      display: inline-block;
      font-size:16px;
      margin-left:10px;
    }
  }
  .comments {
    h3 {
      margin-left:-10px;
    }
    .comment {
      position: relative;
      margin:0 0 30px 0;
      .username {
        display: inline;
        font-weight:bold;
        font-size:16px;
      }
      .date {
        display: inline;
        color:#aaa;
        margin-left:10px;
      }
      .text {
        margin:5px;
      }
      .note-comment {
        position: absolute;
        right:0;
        top:0;
      }
    }
  }
  .long_description {
    h3 {
      margin-left:-10px;
      color:#000;
    }
    color:#888;
    margin-top:290px;
  }
}
</style>
